import Snackbar from '@material-ui/core/Snackbar';

/** @deprecated */
export default Snackbar;
